<gd-dialog-container [closable]="false" [class]="size">
  <div class="header no-border">
    {{ 'txt_legal_disclaimer' | translate }}
  </div>
  <div class="content">
    <p class="disclaimer-text" [innerHTML]="'txt_estimated_taxes_disclaimer' | translate"></p>

    <ui-checkbox [(checked)]="consentGiven">
      {{ 'txt_estimated_taxes_consent_text' | translate }}
    </ui-checkbox>
  </div>
  <div class="actions">
    <button
      class="ui secondary button"
      uiLogEvent
      analyticsKey="Price Navigator Estimated Taxes Disclaimer Cancel Clicked"
      [analyticsEventVersion]="2"
      [analyticsProperties]="{ origin: contextName }"
      (click)="close()"
    >
      {{ 'txt_cancel' | translate }}
    </button>
    <button
      class="ui primary button"
      uiLogEvent
      analyticsKey="Price Navigator Estimated Taxes Disclaimer Continue Clicked"
      [analyticsEventVersion]="2"
      [analyticsProperties]="{ origin: contextName }"
      [disabled]="!consentGiven"
      (click)="continue()"
    >
      {{ 'txt_continue' | translate }}
    </button>
  </div>
</gd-dialog-container>
